(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.normalHeader = document.getElementById('normalHeader');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.isCollectionPage = this.getAttribute('data-page-type') === 'collection';
      this.headerBounds = {};

      this.setupBigLogo();
      if (this.bigLogoHeader) this.bigLogoHeader.classList.add('no-transition');
      this.updateBigLogo(window.pageYOffset || document.documentElement.scrollTop);
      if (this.bigLogoHeader) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.bigLogoHeader.classList.remove('no-transition'));
        });
      }
      this.setHeaderHeight();
      this.checkMobile();

      window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
        this.setHeaderHeight();
        this.checkMobile();
      });

      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.headerResizeObserver = new ResizeObserver(this.setHeaderHeightHandler);
      this.headerResizeObserver.observe(this.header);

      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.headerResizeObserver = new ResizeObserver(this.setHeaderHeightHandler);
      this.headerResizeObserver.observe(this.header);

      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.searchDrawer = document.querySelector('search-drawer');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (Shopify.designMode) {
        this.setupBigLogoHandler = this.setupBigLogo.bind(this);
        document.addEventListener('shopify:section:load', this.setupBigLogoHandler);
        document.addEventListener('shopify:section:unload', this.setupBigLogoHandler);
        document.addEventListener('shopify:section:reorder', this.setupBigLogoHandler);
        document.addEventListener('shopify:section:select', this.setupBigLogoHandler);
        document.addEventListener('shopify:section:deselect', this.setupBigLogoHandler);

        const mainContent = document.getElementById('MainContent');
        if (mainContent) {
          let bigLogoMutationTimeout;
          this.bigLogoMutationObserver = new MutationObserver(() => {
            clearTimeout(bigLogoMutationTimeout);
            bigLogoMutationTimeout = setTimeout(this.setupBigLogoHandler, 50);
          });
          this.bigLogoMutationObserver.observe(mainContent, {
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden'],
            childList: true,
            subtree: true,
          });
        }
      }
    }

    checkMobile() {
      this.isMobile = window.matchMedia('(max-width: 990px)').matches;
    }

    setupBigLogo() {
      const sections = document.querySelectorAll('#MainContent > .shopify-section');
      let firstSection = null;
      for (const section of sections) {
        if (section.offsetHeight > 0 || section.offsetWidth > 0) {
          firstSection = section;
          break;
        }
      }
      const bigLogoSource = firstSection ? firstSection.querySelector('[data-big-logo-section]') : null;

      this.bigLogoMode = bigLogoSource ? bigLogoSource.getAttribute('data-big-logo-mode') : 'off';
      this.headerWrapper = document.getElementById('shopify-section-header-wrapper');
      this.bigLogoHeader = document.getElementById('BigLogoHeader');

      if (this.headerWrapper) this.headerWrapper.classList.remove('normal-header-active', 'big-logo-active');
      if (this.bigLogoHeader) this.bigLogoHeader.classList.remove('big-logo-mode-white', 'big-logo-mode-black');
      this.bigLogoActive = false;

      if (!bigLogoSource || this.bigLogoMode === 'off') {
        if (this.headerWrapper) this.headerWrapper.classList.add('normal-header-active');
        if (this.bigLogoHeader) this.bigLogoHeader.hidden = true;
        return;
      }

      if (!this.bigLogoHeader || !this.headerWrapper) return;

      this.bigLogoHeader.hidden = false;
      this.bigLogoHeader.classList.add('big-logo-mode-' + this.bigLogoMode);
      this.headerWrapper.classList.add('big-logo-active');
      this.bigLogoActive = true;
      this.bigLogoCollapsed = false;

      this.setBigLogoHeaderHeightHandler = this.setBigLogoHeaderHeight.bind(this);
      this.setBigLogoHeaderHeightHandler();
      this.bigLogoHeader.addEventListener('transitionend', this.setBigLogoHeaderHeightHandler);
    }

    setBigLogoHeaderHeight() {
      if (!this.bigLogoHeader) return;
      document.documentElement.style.setProperty('--big-logo-header-height', `${this.bigLogoHeader.offsetHeight}px`);
    }

    updateBigLogo(scrollTop) {
      if (!this.bigLogoActive) return;

      const shrinkStart = 40;
      const collapsePoint = 160;

      if (scrollTop > shrinkStart) {
        this.headerWrapper.classList.add('big-logo-bg-visible');
        this.bigLogoHeader.classList.add('big-logo-shrink');
      } else {
        this.headerWrapper.classList.remove('big-logo-bg-visible');
        this.bigLogoHeader.classList.remove('big-logo-shrink');
      }

      if (scrollTop > collapsePoint) {
        if (!this.bigLogoCollapsed) {
          this.bigLogoCollapsed = true;
          this.bigLogoHeader.classList.add('big-logo-collapsed');
          this.headerWrapper.classList.add('big-logo-collapsed');
        }
      } else if (this.bigLogoCollapsed) {
        this.bigLogoCollapsed = false;
        this.bigLogoHeader.classList.remove('big-logo-collapsed');
        this.headerWrapper.classList.remove('big-logo-collapsed');
        this.headerWrapper.classList.remove('big-logo-bg-visible');
      }

      requestAnimationFrame(this.setBigLogoHeaderHeightHandler);
    }

    shouldActAsAlwaysSticky() {
      if (!this.headerIsAlwaysSticky) return false;
      if (window.innerWidth <= 990 && this.isCollectionPage) return false;
      return true;
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (this.normalHeader) {
        document.documentElement.style.setProperty('--normal-header-height', `${this.normalHeader.offsetHeight}px`);
      }

      const headerDrawer = this.header.querySelector('header-drawer');
      if (headerDrawer && headerDrawer.onResize) headerDrawer.onResize();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.bigLogoHeader && this.setBigLogoHeaderHeightHandler) {
        this.bigLogoHeader.removeEventListener('transitionend', this.setBigLogoHeaderHeightHandler);
      }
      if (this.headerResizeObserver) {
        this.headerResizeObserver.disconnect();
      }
      if (this.setupBigLogoHandler) {
        document.removeEventListener('shopify:section:load', this.setupBigLogoHandler);
        document.removeEventListener('shopify:section:unload', this.setupBigLogoHandler);
        document.removeEventListener('shopify:section:reorder', this.setupBigLogoHandler);
        document.removeEventListener('shopify:section:select', this.setupBigLogoHandler);
        document.removeEventListener('shopify:section:deselect', this.setupBigLogoHandler);
      }
      if (this.bigLogoMutationObserver) {
        this.bigLogoMutationObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.searchDrawer && this.searchDrawer.classList.contains('active')) return;

      if (this.bigLogoActive) {
        this.updateBigLogo(scrollTop);
        if (!this.bigLogoCollapsed) {
          this.currentScrollTop = scrollTop;
          return;
        }
      }

      const scrollDelta = scrollTop - this.currentScrollTop;
      const directionThreshold = 5;
      const pastHeaderThreshold = this.bigLogoActive ? this.headerBounds.bottom : 0;

      if (scrollDelta > directionThreshold && scrollTop > pastHeaderThreshold) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollDelta < -directionThreshold && scrollTop > pastHeaderThreshold) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top + directionThreshold) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.shouldActAsAlwaysSticky()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); 
      this.header.classList.remove('reverse-scroll');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.shouldActAsAlwaysSticky()) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'reverse-scroll');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.shouldActAsAlwaysSticky()) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'reverse-scroll');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || document.querySelector('search-drawer');
      if (this.searchModal) this.searchModal.close();
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
